import { render, staticRenderFns } from "./fgarticont.vue?vue&type=template&id=c76e594e&scoped=true&"
import script from "./fgarticont.vue?vue&type=script&lang=js&"
export * from "./fgarticont.vue?vue&type=script&lang=js&"
import style0 from "./fgarticont.vue?vue&type=style&index=0&id=c76e594e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76e594e",
  null
  
)

export default component.exports